import { stringFormatter } from '@nhl/formatter-utilities';
import { CoreEnums } from '@nhl/nhl-breakaway-ui';

export const getMinColumnSize = (columnId: string, label: string): number => {
    const minimumSize = COLUMN_SIZING[columnId] || 50;
    return label && window.__SITE_LANGUAGE_CODE__ !== CoreEnums.LanguageCode.English
        ? stringFormatter.getLabelSize(label, minimumSize)
        : minimumSize;
};

const COLUMN_SIZING = {
    birthCity: 125,
    birthDate: 105,
    blockedShotsPer60: 60,
    blocksPerGame: 60,
    daysRest: 85,
    defensiveZoneFaceoffLosses: 55,
    defensiveZoneFaceoffPct: 55,
    defensiveZoneFaceoffWins: 55,
    defensiveZoneFaceoffs: 55,
    draftOverall: 60,
    draftRound: 55,
    evFaceoffPct: 55,
    evFaceoffs: 55,
    evFaceoffsLost: 55,
    evFaceoffsWon: 55,
    evGoalsAgainst: 55,
    evGoalsFor: 55,
    evSaves: 55,
    evShotsAgainst: 55,
    evTimeOnIce: 65,
    evTimeOnIcePerGame: 65,
    evenStrengthGoalDifference: 60,
    evenStrengthGoalsAgainst: 60,
    evenStrengthGoalsFor: 60,
    evenStrengthGoalsForPct: 65,
    evenStrengthTimeOnIcePerGame: 65,
    faceoffPct5v5: 55,
    faceoffWinPct: 55,
    faceoffsLost: 55,
    faceoffsWon: 55,
    firstSeasonForGameType: 75,
    franchiseName: 155,
    gameDate: 145,
    gamesPlayedDaysRest0: 60,
    gamesPlayedDaysRest1: 60,
    gamesPlayedDaysRest2: 60,
    gamesPlayedDaysRest3: 60,
    gamesPlayedDaysRest4Plus: 65,
    gamesRelievedSavePct: 65,
    gamesStartedGoalsAgainst: 55,
    gamesStartedSavePct: 65,
    gamesStartedSaves: 55,
    gamesStartedShotsAgainst: 55,
    giveawaysPer60: 60,
    goalieFullName: 130,
    goalsAgainst: 55,
    goalsAgainstPerGame: 55,
    goalsCradle: 55,
    goalsFor: 55,
    goalsForPerGame: 55,
    goalsPct: 60,
    hitsPer60: 60,
    hitsPerGame: 60,
    individualSatForPer60: 65,
    lossLeadPeriod1: 65,
    lossLeadPeriod2: 65,
    lossTrailPeriod1: 65,
    lossTrailPeriod2: 65,
    lossesEvenShots: 80,
    lossesOutshootOpponent: 105,
    lossesOutshotByOpponent: 105,
    lossesOneGoalGames: 85,
    lossesTwoGoalGames: 85,
    lossesThreeGoalGames: 85,
    minors: 55,
    nationalityCode: 55,
    netGoalsPerGame: 55,
    netMinorPenaltiesPer60: 85,
    netPenaltiesPer60: 75,
    netShotsPerGame: 55,
    neutralZoneFaceoffLosses: 55,
    neutralZoneFaceoffPct: 55,
    neutralZoneFaceoffWins: 55,
    neutralZoneFaceoffs: 55,
    offensiveZoneFaceoffLosses: 55,
    offensiveZoneFaceoffPct: 55,
    offensiveZoneFaceoffWins: 55,
    offensiveZoneFaceoffs: 55,
    onIceShootingPct5v5: 55,
    onIceShootingPct: 55,
    otLossLeadPeriod1: 65,
    otLossLeadPeriod2: 65,
    otLossTrailPeriod1: 65,
    otLossTrailPeriod2: 65,
    otLossesEvenShots: 85,
    otLossesOneGoalGames: 85,
    otLossesOutshootOpponent: 105,
    otLossesOutshotByOpponent: 120,
    otTimeOnIce: 65,
    otTimeOnIcePerOtGame: 85,
    penalties: 55,
    penaltiesDrawn: 55,
    penaltiesDrawnPer60: 75,
    penaltiesTakenPer60: 75,
    penaltyMinutesPerGame: 60,
    penaltyMinutesPerTimeOnIce: 75,
    penaltySecondsPerGame: 65,
    penaltyShotsGoalsAgainst: 55,
    penaltyShotsSaves: 55,
    period1GoalsAgainst: 55,
    period1GoalsFor: 55,
    period2GoalsAgainst: 55,
    period2GoalsFor: 55,
    period3GoalsAgainst: 55,
    period3GoalsFor: 55,
    pkTimeOnIcePerGame: 65,
    powerPlayGoalFor: 60,
    powerPlayGoalsAgainst: 60,
    powerPlayTimeOnIcePerGame: 65,
    ppFaceoffPct: 55,
    ppFaceoffs: 55,
    ppFaceoffsLost: 55,
    ppFaceoffsWon: 55,
    ppGoalsAgainstPer60: 55,
    ppGoalsFor: 55,
    ppGoalsForPer60: 55,
    ppGoalsPer60: 65,
    ppIndividualSatForPer60: 65,
    ppOpportunities: 55,
    ppOpportunitiesPerGame: 65,
    ppPointsPer60: 65,
    ppPrimaryAssistsPer60: 75,
    ppSecondaryAssistsPer60: 75,
    ppShotsPer60: 55,
    ppTimeOnIce: 65,
    ppTimeOnIcePctPerGame: 55,
    ppTimeOnIcePerGame: 65,
    primaryAssistsPer605v5: 55,
    primaryAssistsPerGame: 55,
    qualityStartsPct: 60,
    sat: 55,
    satAgainst: 55,
    satAhead: 55,
    satBehind: 55,
    satClose: 55,
    satFor: 55,
    satForAhead: 55,
    satForBehind: 55,
    satForClose: 55,
    satForTied: 55,
    satPercentageAhead: 55,
    satPercentageBehind: 55,
    satPercentageClose: 55,
    satPercentageTied: 55,
    satRelative: 65,
    satTied: 55,
    savePctDaysRest0: 60,
    savePctDaysRest1: 60,
    savePctDaysRest2: 60,
    savePctDaysRest3: 60,
    savePctDaysRest4Plus: 65,
    saves: 55,
    seasonId: 75,
    secondaryAssistsPer605v5: 55,
    secondaryAssistsPerGame: 55,
    shFaceoffPct: 55,
    shFaceoffs: 55,
    shFaceoffsLost: 55,
    shFaceoffsWon: 55,
    shGoalsFor: 55,
    shGoalsPer60: 65,
    shIndividualSatForPer60: 65,
    shPointsPer60: 65,
    shPrimaryAssistsPer60: 75,
    shSecondaryAssistsPer60: 75,
    shTimeOnIce: 65,
    shTimeOnIcePerGame: 65,
    shiftsPerGame: 75,
    shootingPct5v5: 55,
    shootingPctCradle: 55,
    shootingPctDeflected: 55,
    shortHandedGoalsAgainst: 60,
    shortHandedGoalsFor: 60,
    shortHandedTimeOnIcePerGame: 65,
    shotDifferentialPerGame: 55,
    shotsAgainst: 55,
    shotsAgainstPerGame: 55,
    shotsForPerGame: 75,
    shotsOnNet: 55,
    shotsOnNetCradle: 55,
    shotsOnNetWrist: 55,
    skaterFullName: 130,
    skaterSavePct5v5: 55,
    skaterShootingPlusSavePct5v5: 70,
    takeawaysPer60: 60,
    teamAbbrev: 65,
    teamAbbrevs: 65,
    teamFullName: 155,
    tiesEvenShots: 80,
    tiesLeadPeriod1: 65,
    tiesLeadPeriod2: 65,
    tiesOutshootOpponent: 105,
    tiesOutshotByOpponent: 105,
    tiesTrailPeriod1: 65,
    tiesTrailPeriod2: 65,
    timeOnIce3v4: 65,
    timeOnIce3v5: 65,
    timeOnIce4v3: 65,
    timeOnIce4v5: 65,
    timeOnIce5v3: 65,
    timeOnIce5v4: 65,
    timeOnIce: 75,
    timeOnIcePerGame5v5: 60,
    timeOnIcePerGame: 60,
    timeOnIcePerShift: 70,
    timeOnIcePp: 65,
    timeOnIceShorthanded: 65,
    timesShorthanded: 55,
    totalFaceoffLosses: 55,
    totalFaceoffWins: 55,
    totalFaceoffs: 65,
    usat: 55,
    usatAgainst: 55,
    usatAhead: 55,
    usatBehind: 55,
    usatClose: 55,
    usatFor: 55,
    usatForAhead: 55,
    usatForBehind: 55,
    usatForClose: 55,
    usatForTied: 55,
    usatPercentage: 60,
    usatPercentageAhead: 60,
    usatPercentageBehind: 60,
    usatPercentageClose: 60,
    usatPercentageTied: 60,
    usatPrecentageClose: 60,
    usatRelative: 65,
    usatTied: 55,
    winPctLeadPeriod1: 65,
    winPctLeadPeriod2: 65,
    winPctOneGoalGames: 85,
    winPctTrailPeriod1: 65,
    winPctTrailPeriod2: 65,
    winPctThreeGoalGames: 85,
    winPctTwoGoalGames: 85,
    winsEvenShots: 80,
    winsLeadPeriod1: 65,
    winsLeadPeriod2: 65,
    winsOneGoalGames: 85,
    winsOutshootOpponent: 105,
    winsOutshotByOpponent: 105,
    winsTrailPeriod1: 65,
    winsTrailPeriod2: 65,
    winsThreeGoalGames: 85,
    winsTwoGoalGames: 85,
};
